export const CHECKFREE_ALERT_VARIANTS = {
  NO_ERROR: 'NO_ERROR',
  ERROR_SUBMITTING_FORM: 'ERROR_SUBMITTING_FORM',
  API_VALIDATION_ERROR: 'API_VALIDATION_ERROR',
  API_SUCCESS: 'API_SUCCESS'
} as const;

export const USER_MANAGEMENT_MODAL_VARIANTS = {
  CLOSED: 'CLOSED',
  ADD_USER_SUCCESS: 'ADD_USER_SUCCESS',
  MODIFY_USER_SUCCESS: 'MODIFY_USER_SUCCESS',
  CHECKFREE_USER_FETCH_FAILED: 'CHECKFREE_USER_FETCH_FAILED'
};

export const CHECKFREE_TAB_VALUES = {
  USER_MANAGEMENT: 'userManagement',
  ACCOUNT_MANAGEMENT: 'accountManagement'
};

export const CHECKFREE_SSO_VENDOR_CODE = 'NEWCHECKFREE';
export const MIN_AGE_FOR_CHECKFREE_ENROLMENT = 18;
export const ACCOUNTS_GRID_PAGESIZE = 10;
export const USER_MANAGEMENT_GRID_PAGESIZE = 10;
export const LIFESPAN_IN_YEARS = 100;
export const DATEPICKER_VALUE_ARRAY_LENGTH = 2;

export const CHECKFREE_AUTH_LEVEL = {
  LEVEL_1: 'LEVEL_1',
  LEVEL_2: 'LEVEL_2',
  LEVEL_3: 'LEVEL_3'
};

export const CHECKFREE_MODULES = {
  ACCOUNT: 'account',
  USER: 'user'
};

export const CHECKFREE_ROUTES = {
  BILLPAY_MANAGEMENT: '/checkfree',
  ADD_BILLPAY_ACCOUNT: `/checkfree/${CHECKFREE_MODULES.ACCOUNT}/add`,
  ADD_USER: `/checkfree/${CHECKFREE_MODULES.USER}/add`,
  MODIFY_USER: `/checkfree/${CHECKFREE_MODULES.USER}/modify`
};

export const ACCOUNT_MANAGEMENT_COLUMNS = {
  ACCOUNT_NAME: 'accountName',
  ACCOUNT_NUMBER: 'accountNumber',
  ACTIONS: 'actions',
  STATUS: 'status',
  BILL_PAY_FEE_ACCOUNT: 'billingAccount'
};

export const USER_MANAGEMENT_COLUMNNS = {
  FIRST_NAME: 'firstName',
  AUTHORIZATION_LEVEL: 'authorizationLevel',
  STATUS: 'status',
  ACTIONS: 'actions',
  USER_CODE: 'userCode'
};

export const USER_MANAGEMENT_FIELD_LENGTH_VALIDATORS = {
  TAXID: { MIN: 9, MAX: 9 }
};

export enum ACCOUNT_MANAGEMENT_GRID_ACTIONS {
  MODIFY_BILL_PAY_FEE_ACCOUNT = 'MODIFY_BILL_PAY_FEE_ACCOUNT',
  DEACTIVATE_ACCOUNT = 'DEACTIVATE_ACCOUNT'
}
